<div class="ya-bottomsheet-container ya-typography">
  <ya-bottomsheetclosebottom [bottomSheetRef]="bottomSheetRef"></ya-bottomsheetclosebottom>
  <div class="ya-bottomsheet-content-center">
    <h2>
      <span langkey="phBonusAction_Your_QR"></span>
    </h2>
    <qr-code-display [qrData]="webVoucherNo" [autoActivate]="true" [animate]="true"></qr-code-display>
    <div class="qrcode-text">
      <div class="inline-icon hyp-filter-svg" inlineSVG="shop-icons.svg#ya-hypersoft-bonus"></div>
      <h4>{{userWebvoucherViewModel.webvoucherNumber}}</h4>
    </div>

    <div class="ya-dialog-action">
      <div class="ya-button-container">
        <button mat-button [ngClass]="'mat-button ya-caption no-hover'" (click)="OpenWebVoucherModal()">
          <span langkey="phWebvoucherDetail_button_Title"></span>
        </button>
      </div>
    </div>
  </div>
</div>